import ProgressBar from 'progressbar.js';

const ALL = '[data-progress]';

// For full API reference, see the Bootstrap docs, although this is all custom 🤷‍♂️:
// https://getbootstrap.com/docs/4.3/components/progress/

class RadialProgressBar {
  constructor(element) {
    this.element = element;
    this.progressBar = new ProgressBar.Circle(element, {
      strokeWidth: this.element.dataset.progressStrokeWidth || 8,
      easing: 'easeInOut',
      duration: 400,
      color: this.element.dataset.progressColor || '#5D3AC5',
      trailColor: this.element.dataset.trailColor || '#F2F0FA',
      svgStyle: null
    });

    this.observeDataProgress();
  }

  animate() {
    const percentProgress = parseFloat(this.element.dataset.progress) / 100;
    this.progressBar.animate(percentProgress);
  }

  observeDataProgress() {
    this.progressObserver.observe(this.element, { attributes: true });
  }

  onDataProgressChange(mutations) {
    this.animate();
  }

  get progressObserver() {
    return new MutationObserver((mutations) => this.onDataProgressChange(mutations));
  }
}

const intializeRadialProgressBar = (progress) => {
  if(progress.dataset.progressBarInitialized) return;

  progress.dataset.progressBarInitialized = true;

  const progressBar = new RadialProgressBar(progress);
  if (parseFloat(progress.dataset.progress) > 0) {
    progressBar.animate();
  }
}

// Expose a simple function for selecting all progress radial bars currently present in the DOM,
// and for binding a MutationObserver that sets and animates progress for radial bars
const attachAll = (options) => {
  // This sets (animates) and observes all radial progress bars present in the DOM on page render
  document.querySelectorAll(ALL).forEach((progress) => {
    intializeRadialProgressBar(progress)
  })

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.target.querySelectorAll(ALL).forEach(progress => {
        intializeRadialProgressBar(progress)
      })
    })
  })

  observer.observe(document.body, { childList: true, subtree: true });
}

export default { attachAll }
